// moz667: por culpa de vrdemo
var $ = jQuery;

window.audit_click = function (current_page, extra_click_info, on_complete) {
    current_page = !current_page && document && document.location ? document.location.pathname : current_page;

    $.ajax({
        method: "GET", // FIXME: hacer que sea POST, por ahora es GET ya que si no tenemos que lidiar con el CSRF
        url: N2M.AUDIT_CLICK_URL,
        data: {
            p: current_page,
            e: extra_click_info
        }
    }).always(function() {
        if (on_complete) on_complete();
    });
};

$(".audit-click").each(function () {
    if (N2M.AUDIT_CLICK_URL) {
        var $link = $(this);

        $link.on("click", function (e) {
            var extra_click_info = $link.data('extra');

            if (extra_click_info) {
                var current_page = $link.attr("href");
                audit_click(current_page, extra_click_info);

            }
        });
    }
});

